import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import Paper from '@material-ui/core/Paper';
import Intäkter from "../Inputs/LargeDesktop/PrognosIntäkter";
import MånadensAffär from "../Inputs/LargeDesktop/MånadensAffär";
import StörstaAffärer from "../Inputs/LargeDesktop/StörstaAffärer";
import Budget from "../Inputs/LargeDesktop/Budget";

const ReactGridLayout = WidthProvider(RGL);

// Lägg till/Ta bort "static: true" på paper för göra boxarna flyttbara eller statiska
export default class StaticElementsLayout extends React.PureComponent {

  render() {
    return (
      <ReactGridLayout
        className="layout"
        rowHeight={40}
        style={{ backgroundColor: '#075a5f', minHeight:'Calc(100vh - 100px)', paddingTop:'4px' }}
      >
        <Paper style={{ backgroundColor: '#0c969c' }} key="1" data-grid={{ x: 0, y: 7, w: 8, h: 10, static: true }}>
          <span className="text"><Intäkter /></span>
        </Paper>
        <Paper style={{ backgroundColor: '#0c969c' }} key="2" data-grid={{ x: 0, y: 0, w: 4, h: 7, static: true }}>
          <span className="text"><Budget /></span>
        </Paper>
        <Paper style={{ backgroundColor: '#0c969c' }} key="3" data-grid={{ x: 4, y: 0, w: 4, h: 7, static: true }}>
          <span className="text"><MånadensAffär /></span>
        </Paper>
        <Paper style={{ backgroundColor: '#0c969c' }} key="4" data-grid={{ x: 8, y: 0, w: 4, h: 17, static: true }}>
          <span className="text"><StörstaAffärer /></span>
        </Paper>
      </ReactGridLayout>
    );
  }
}